import type {
  ISocialProofDataSourceParam,
  PartialSocialProofData,
} from "@shared/common/types/data-source";

export const fetchSocialProof = async ({
  sourceParam,
  extraArgs,
}: {
  sourceParam: ISocialProofDataSourceParam;
  extraArgs: { siteId: string; productId: string };
}): Promise<PartialSocialProofData["data"]> => {
  const url = PUBLIC_API_URL + "/social-proof/product-count";

  if (sourceParam.type !== "SOCIAL_PROOF") {
    throw new Error("Invalid sourceParam type");
  }

  if (
    sourceParam.eventType !== "PAGEVIEW" &&
    sourceParam.eventType !== "PURCHASE"
  ) {
    throw new Error("Invalid eventType");
  }

  if (!extraArgs.productId) {
    throw new Error("required productId");
  }

  if (!extraArgs.siteId) {
    throw new Error("required siteId");
  }

  const res = await fetch(
    `${url}?type=${sourceParam.eventType}&period=${sourceParam.period}&unit=${sourceParam.unit}&productId=${extraArgs.productId}&siteId=${extraArgs.siteId}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }
  );

  if (!res.ok) {
    throw new Error("Failed to fetch data");
  }

  const result = await res.json();
  return { type: "social_proof", ...result };
};
